import { render, staticRenderFns } from "./Klachtenprocedure.vue?vue&type=template&id=48a73d54&"
import script from "./Klachtenprocedure.vue?vue&type=script&lang=js&"
export * from "./Klachtenprocedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports